import { applyMiddleware, createStore, compose } from "redux";
import thunk from "redux-thunk";
import api from "../api/api";
import reducers from "../reducers";
import cxaApi from "../api/flexapi";

/**
 * @see [import api from 'middleware/api'] for 'actions/insuranceAction'
 */
const thunkWithExtraArg = thunk.withExtraArgument(cxaApi);
const middleware = applyMiddleware(thunkWithExtraArg, api);

/**
 * @see {@link https://github.com/zalmoxisus/redux-devtools-extension}
 */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState = {}) {
  const store = createStore(reducers, initialState, composeEnhancers(middleware));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("../reducers", () => {
      const nextRootReducer = require("../reducers").default;

      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./store/configureStore.dev.js